import type { AnalysisResult } from './excelImportMeta';

/**
 * One-shot handoff between the Excel-import modal and the
 * `/purchases/file-import` page. The modal stores the analysis result just
 * before navigating; the page consumes it exactly once on mount. A direct
 * visit / refresh finds nothing and redirects back to /purchases — by design,
 * since a stale draft referencing moved/deleted entities is worse than
 * re-uploading. (Deliberately not router state: the repo doesn't use
 * `location.state`, and module scope keeps this a trivially testable pure
 * `.ts` seam.)
 */

let pending: AnalysisResult | null = null;

export const setPendingImport = (result: AnalysisResult): void => {
    pending = result;
};

/**
 * Read the stored result without clearing it. Pure, so it's safe inside a
 * `useState` initializer — StrictMode double-invokes initializers in dev, and
 * a destructive read there would hand the second invocation `null` and bounce
 * the page back to /purchases right after a successful upload.
 */
export const peekPendingImport = (): AnalysisResult | null => pending;

/** Clear the handoff — call from an effect once the page has read it. */
export const clearPendingImport = (): void => {
    pending = null;
};
